import { useIntl } from 'react-intl'
import { formatCurrency } from 'shared/components/FormattedCurrency/formatCurrency'
import { lang } from '../lang'

type Props = {
  isFinalAmountError: boolean
  minAmountInBaseCurrency: number
  fiatAmount: string | null
  isPostDonateRequestError: boolean
  isRequestsLoading: boolean
  baseCurrencyCode?: string
}

export const useError = ({
  isFinalAmountError,
  minAmountInBaseCurrency,
  fiatAmount,
  baseCurrencyCode,
  isPostDonateRequestError,
  isRequestsLoading,
}: Props) => {
  const intl = useIntl()

  const isMinAmountError = minAmountInBaseCurrency > Number(fiatAmount)

  if (isMinAmountError) {
    return intl.formatMessage(lang.minError, {
      amount: formatCurrency(intl.locale, { value: minAmountInBaseCurrency, currency: baseCurrencyCode }),
    })
  }

  if (isRequestsLoading) {
    return
  }

  const hasErrors = isFinalAmountError || isPostDonateRequestError

  if (!hasErrors) {
    return
  }

  return intl.formatMessage(lang.commonError)
}
